module.exports = __webpack_public_path__ + "img/gallagher-globe-logo-flat.b9cdd5c8.png";